import styled from 'styled-components'
import type { PaletteKeys } from '../../../styled'
import Dot from '../../atoms/Dot/Dot'

export type LabeledDotProps = {
  colour: PaletteKeys
  label: string
}

const Wrapper = styled.div`
  display: flex;
`

const Label = styled.div`
  display: flex;

  background-color: ${({ theme }) => theme.palette.white};
  border-radius: 108px;
`

const Text = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;

  margin: 4.5px 10px;

  white-space: nowrap;
`

function LabeledDot(props: LabeledDotProps) {
  const { colour, label } = props

  return (
    <Wrapper>
      <Label>
        <Dot colour={colour} />
        <Text>{label}</Text>
      </Label>
    </Wrapper>
  )
}

export default LabeledDot
